module.exports = __webpack_public_path__ + "2e488464c1af79b383071eda2970d37c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/skype.png
// module id = ./assets/images/advisory/skype.png
// module chunks = 0